import { render, staticRenderFns } from "./MapCropCard.vue?vue&type=template&id=3513a9a8&scoped=true&"
import script from "./MapCropCard.vue?vue&type=script&lang=js&"
export * from "./MapCropCard.vue?vue&type=script&lang=js&"
import style0 from "./MapCropCard.vue?vue&type=style&index=0&id=3513a9a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3513a9a8",
  null
  
)

export default component.exports